import { selectLanguage, setLanguage } from "./localizeSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useEffect, useRef } from "react";

export function LocalizeSelector() {
    const dispatch = useAppDispatch();
    const languageCode = useAppSelector(selectLanguage);
    const languageSelect = useRef<HTMLSelectElement>(null);

    const OnLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedLanguage = event.target.value;
        if (selectedLanguage !== languageCode) {
            dispatch(setLanguage(selectedLanguage));
        }
    };

    useEffect(() => {
        if (languageSelect.current) {
            languageSelect.current.value = languageCode ?? "en";
        }
    }
    , [languageCode]);

    return (
        <select ref={languageSelect} id="languageSelect" defaultValue={languageCode} className="font-medium text-lg w-full outline-1 outline-offset-2 outline-gray-300 dark:outline-gray-600 rounded-sm bg-white dark:bg-gray-800 stroke-black dark:text-white" onChange={OnLanguageChange}>
            <option value="de">🇩🇪 Deutsch</option>
            <option value="en">🇬🇧 English</option>
            <option value="tr">🇹🇷 Türkçe</option>
            <option value="uk">🇺🇦 Українська</option>
            <option value="ru">🇷🇺 Русский</option>
            <option value="it">🇮🇹 Italiano</option>
            <option value="es">🇪🇸 Español</option>
            <option value="fr">🇫🇷 Français</option>
        </select>
    )
}